<template>
    <az-container>
        <az-form>
            <v-data-table :headers="colunas" :items="itens" :total-items="totalItens"
                          :pagination.sync="paginacaoInterna" :loading="false" :style="cssVar"
                          no-data-text="Você ainda não lançou proposta em nenhuma compra direta" hide-actions
                          class="az-table-list minhas-tabela">
                <template slot="items" slot-scope="props">
                    <tr @click="$emit('acessar', props.item.id)">
                        <td>
                            {{ props.item.dataHoraEncerramento | az-date(humanizarFormatoData(props.item.dataHoraEncerramento)) }}<br>
                            <span v-if="props.item.dataHoraEncerramento">
                                {{ props.item.dataHoraEncerramento | az-date(humanizarFormatoHora(props.item.dataHoraEncerramento)) }}
                            </span>
                        </td>
                        <td>
                            {{ props.item.processo }}
                            <br>
                            <span v-if="props.item.quantidadeRepeticoes">
                                <strong> Repetição: {{props.item.quantidadeRepeticoes}} </strong>
                            </span>
                        </td>
                        <td>
                            <expansao-texto :tamanho="125" :texto="props.item.objeto"/>
                        </td>
                        <td>
                            {{ props.item.tipo | cdEnum(tiposCompraDireta)}}
                        </td>
                        <td>
                            {{ props.item.orgao }}
                        </td>
                        <td>
                            {{ props.item.situacao | azEnum(situacoesCompraDireta) }}
                        </td>
                        <td class="table-actions">
                            <v-tooltip top>
                                <a slot="activator">
                                    <i class="fas fa-sign-in-alt pr-2" aria-hidden="true"/>
                                    <span class="acao-mobile">Acessar</span>
                                </a>
                                Acessar
                            </v-tooltip>
                            <v-tooltip top v-if="props.item.sequencialCompraPublica">
                                <a @click="$emit('acessarPncp', props.item)" slot="activator">
                                    <i class="fas fa-external-link-alt" aria-hidden="true"/>
                                    <span class="acao-mobile">Acessar no PNCP</span>
                                </a>
                                Acessar no PNCP
                            </v-tooltip>
                        </td>
                    </tr>
                </template>
            </v-data-table>
            <div class="az-pagination">
                <v-pagination v-model="paginacaoInterna.page" :length="paginas"/>
                <div class="az-select-pagination">
                    <span>Linhas por página:</span>
                    <v-select :items="linhasPorPagina" v-model="paginacaoInterna.rowsPerPage"/>
                </div>
            </div>
        </az-form>
    </az-container>
</template>

<script>
import {mapState} from 'vuex'
import {situacoesCompraDireta, situacoesProposta, tiposCompraDireta} from '@/core/constants'

export default {
    name: 'MinhasComprasDiretasTabela',
    props: ['paginas', 'paginacao', 'totalItens', 'itens'],
    data() {
        return {
            situacoesCompraDireta,
            situacoesProposta,
            colunas: [
                {
                    value: 'dataHoraEncerramento',
                    sortable: true,
                    text: 'Encerramento',
                    align: 'left',
                    width: '40px',
                    class: 'primary--text'
                },
                {
                    value: 'processo',
                    sortable: true,
                    text: 'Nº Processo',
                    align: 'left',
                    width: '100px',
                    class: 'primary--text'
                },
                {
                    value: 'objeto',
                    sortable: true,
                    text: 'Objeto',
                    align: 'left',
                    width: '180px',
                    class: 'primary--text'
                },
                {
                    value: 'tipo',
                    sortable: true,
                    text: 'Tipo',
                    align: 'left',
                    width: '80px',
                    class: 'primary--text'
                },
                {
                    value: 'orgao',
                    sortable: false,
                    text: this.$t('main.fornecedor_minhas_compras_diretas_orgao.text'),
                    align: 'left',
                    width: '30px',
                    class: 'primary--text'
                },
                {
                    value: 'situacao',
                    sortable: true,
                    text: 'Situação',
                    align: 'left',
                    width: '50px',
                    class: 'primary--text'
                },
                {
                    sortable: false,
                    align: 'center',
                    text: 'Ações',
                    width: '30px',
                    class: 'primary--text'
                }
            ],
            linhasPorPagina: [10, 25, 50, 100],
            paginacaoInterna: this.paginacao,
            tiposCompraDireta
        }
    },
    computed: {
        ...mapState(['loki']),
        cssVar() {
            const labelOrgao = this.$t('main.fornecedor_minhas_compras_diretas_orgao.text')
            return {
                '--label-orgao': `"${labelOrgao}:"`
            }
        }
    },
    watch: {
        paginacaoInterna: {
            handler(novoValor) {
                this.$emit('paginar', novoValor)
            },
            deep: true
        }
    }
}
</script>

<style scoped lang="stylus">
    .az-container
        margin-bottom 60px

    .minhas-tabela
        .acao-mobile
            display none

        td:hover
            cursor pointer !important

    @media (max-width 720px)
        .minhas-tabela
            td:nth-of-type(1):before
                content "Encerramento:"

            td:nth-of-type(2):before
                content "Nº Processo:"

            td:nth-of-type(3):before
                content "Objeto:"

            td:nth-of-type(4):before
                content "Tipo:"

            td:nth-of-type(5):before
                content var(--label-orgao)

            td:nth-of-type(6):before
                content "Situação:"

            td:nth-of-type(7):before
                content "Proposta:"

            td:nth-of-type(8):before, td:nth-of-type(1) br
                display none

            .acao-mobile
                display inline-block
                margin-left 3px

    @media (max-width 500px)
        .az-container
            margin 0
</style>
